import useStructuresWorkspace from '../../structure/hooks/useStructuresWorkspace';

function useCommanderIdsByWorkspace(workspaceId: string | undefined) {
  const { data, ...rest } = useStructuresWorkspace(workspaceId, {
    skip: !workspaceId,
  });
  const commanders = data?.commanderIds;
  return {
    commanders,
    ...rest,
  };
}

export default useCommanderIdsByWorkspace;
